export default __webpack_public_path__ + "static/assets/med_capsule_V_semi_01_m.39e5833e.png";